import { t } from '@/i18n';
import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';

export const partnersBreadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.partners.breadcrumb.partners_label1'),
  },
];
